var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Watch } from "vue-facing-decorator";
import { CompaniesClient, GetCompanyViewPaginatedQuery, PaginatedEnumerableOfCompanyQuery, AccountStatusEnum, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
const companiesClient = new CompaniesClient(window.apiUrl);
const maxNumberOfSystems = 10;
let CompaniesVue = class CompaniesVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "CompanyName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetCompanyViewPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            showUnhealthyOnly: false,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfCompanyQuery();
        this.columns = [
            { visible: true, fieldName: "companyName", title: "Name" },
            { visible: true, fieldName: "streetAddress3", title: "City" },
            { visible: true, fieldName: "streetAddress4", title: "State" },
            { visible: true, fieldName: "countryName", title: "Country" },
            { visible: true, fieldName: "companyCode", title: "Ref" },
            { visible: true, fieldName: "accountCombinedStatus", title: "Account Status" },
        ];
        this.accountStatusOptions = [
            { value: null, text: `All account statuses`, suffix: '', suffixPast: '' },
            { value: AccountStatusEnum.Active, text: `Active`, suffix: 'left', suffixPast: 'overdue' },
            { value: AccountStatusEnum.Overdue, text: `Overdue`, suffix: 'ago', suffixPast: 'ago' },
            { value: AccountStatusEnum.Suspended, text: `Suspended`, suffix: 'left', suffixPast: 'overdue' },
        ];
    }
    created() {
        this.loadDataGridState();
        this.search();
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        companiesClient
            .search(this.query)
            .then((response) => {
            this.data = new PaginatedEnumerableOfCompanyQuery();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("company-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    edit(company) {
        this.$router.push({ name: RouteNames.Company, params: { id: company.companyId.toString() } });
    }
    ;
    archive(company) {
        if (this.working)
            return;
        companiesClient
            .getArchiveImpact(company.companyId)
            .then((impact) => {
            const parts = [];
            if (impact.sitesCount > 0) {
                parts.push(`${impact.sitesCount} site${impact.sitesCount === 1 ? '' : 's'}`);
            }
            if (impact.systemsCount > 0) {
                parts.push(`${impact.systemsCount} system${impact.systemsCount === 1 ? '' : 's'}`);
            }
            if (impact.usersCount > 0) {
                parts.push(`${impact.usersCount} user${impact.usersCount === 1 ? '' : 's'}`);
            }
            let msg;
            if (parts.length > 0) {
                let subjects = '';
                if (parts.length === 1) {
                    subjects = parts[0];
                }
                else if (parts.length === 2) {
                    subjects = `${parts[0]} and ${parts[1]}`;
                }
                else {
                    subjects = `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
                }
                msg = `Archiving this company will also archive ${subjects}. Are you sure you want to continue?`;
            }
            else {
                msg = "Are you sure that you want to archive this company?";
            }
            this.$confirmModal.show(msg)
                .then((value) => {
                if (!value)
                    return;
                this.performArchive(company);
            });
        });
    }
    performArchive(company) {
        this.working = true;
        companiesClient
            .delete(company.companyId)
            .then(() => {
            company.whenDeleted = new Date();
            Notifier.onOk(`Company # ${company.companyId} has been successfully archived.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    restore(company) {
        if (this.working)
            return;
        this.working = true;
        companiesClient
            .restore(company.companyId)
            .then(() => {
            company.whenDeleted = undefined;
            Notifier.onOk(`Company # ${company.companyId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getCombinedAddress(company) {
        if (!company.primaryAddressId)
            return "";
        return [company.streetAddress1, company.streetAddress2, company.streetAddress3, company.streetAddress4, company.countryName].filter((item) => { return item; }).join(", ") || "No details entered.";
    }
    ;
    getAccountCombinedStatus(company) {
        const statusOption = this.accountStatusOptions.find(item => item.value === company.accountStatus);
        const statusText = statusOption ? statusOption.text : "";
        let daysDue = null;
        if (company.accountDueDate) {
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            let dueDate = company.accountDueDate;
            const diffDays = Math.ceil((dueDate - now) / (1000 * 60 * 60 * 24));
            daysDue = Math.abs(diffDays).toString();
            const uom = daysDue == 1 ? 'day' : 'days';
            daysDue = diffDays >= 0 ? `${daysDue} ${uom} ${statusOption.suffix}` : `${daysDue} ${uom} ${statusOption.suffixPast}`;
        }
        return daysDue
            ? `${statusText} (${daysDue})`
            : statusText;
    }
    getCriticalSystemsBadge(company) {
        return `${TextHelper.formatNumericStatusField(company.totalNumberOfCriticalSystems || 0, maxNumberOfSystems)} critical`;
    }
    ;
    getWarningSystemsBadge(company) {
        return `${TextHelper.formatNumericStatusField(company.totalNumberOfWarningSystems || 0, maxNumberOfSystems)} warned`;
    }
    ;
    getHealthySystemsBadge(company) {
        let totalNumberOfSystems = company.totalNumberOfSystems || 0;
        let totalNumberOfCriticalSystems = company.totalNumberOfCriticalSystems || 0;
        let totalNumberOfWarningSystems = company.totalNumberOfWarningSystems || 0;
        let numberOfHealthySystems = totalNumberOfSystems - (totalNumberOfCriticalSystems + totalNumberOfWarningSystems);
        return `${TextHelper.formatNumericStatusField(numberOfHealthySystems, maxNumberOfSystems)} healthy`;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("company-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
    get isClientAdministrator() {
        return this.loginState.isClientAdministratorUser;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompaniesVue.prototype, "loginState", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.showUnhealthyOnly"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompaniesVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompaniesVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompaniesVue.prototype, "onSortChanged", null);
CompaniesVue = __decorate([
    Component({
        name: "CompaniesVue"
    })
], CompaniesVue);
export default CompaniesVue;
